"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveListLayoutRequestSchema = exports.listLayoutsSchema = exports.listLayoutSchema = exports.LIST_KEY_PATTERN = exports.listCardSchema = exports.CARD_DETAIL_SLOTS = exports.LIST_VIEWS = void 0;
const zod_1 = require("zod");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 20 Oct 2026 · A LIST AS A TABLE OR AS CARDS, AND WHAT THE CARD SHOWS.     │
 * │ decisions.md LV-1, `0224`.                                                │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * Every list can be read as cards, on a desktop and on a phone, and each person decides what their
 * card shows (the product owner, 20 Oct 2026 — *"much like Jira"*). This is the shape of that
 * choice, kept per member per list on the server so the phone and the desktop agree.
 *
 * ⚠️⚠️ **THE TITLE AND THE CONTEXT LINE ARE NOT HERE, BECAUSE THEY ARE NOT FREE.** They are the
 * entity's name and what it belongs to, the same on every card of that list. Every other slot is a
 * column key of the list — a metafield is `mf.<key>` — or null for an empty slot.
 */
exports.LIST_VIEWS = ['list', 'cards'];
/** How many detail lines a card has room for. */
exports.CARD_DETAIL_SLOTS = 4;
const columnKey = zod_1.z.string().min(1).max(80);
/**
 * The card's free slots.
 *
 * ```
 *  ┌──────────────────────────────────┐
 *  │ context                   [badge]│
 *  │ title                            │
 *  │ details[0]        details[1]     │
 *  │ details[2]        details[3]     │
 *  │ footer                   (avatar)│
 *  └──────────────────────────────────┘
 * ```
 */
exports.listCardSchema = zod_1.z.strictObject({
    badge: columnKey.nullable(),
    avatar: columnKey.nullable(),
    details: zod_1.z.array(columnKey.nullable()).max(exports.CARD_DETAIL_SLOTS),
    footer: columnKey.nullable(),
});
exports.LIST_KEY_PATTERN = /^[a-z0-9][a-z0-9:._-]{0,79}$/u;
exports.listLayoutSchema = zod_1.z.object({
    listKey: zod_1.z.string(),
    /** The desktop's view. Null until the person picks one — the table. */
    view: zod_1.z.enum(exports.LIST_VIEWS).nullable(),
    /**
     * 20 Oct 2026 · the phone's view, kept apart from the desktop's. Null until the person picks one
     * on a phone — cards.
     */
    mobileView: zod_1.z.enum(exports.LIST_VIEWS).nullable(),
    /** Null until the person changes the card — the list's own default card. */
    card: exports.listCardSchema.nullable(),
});
exports.listLayoutsSchema = zod_1.z.object({ data: zod_1.z.array(exports.listLayoutSchema) });
/**
 * `PUT /workspace/list-layouts/:key` — the desired state of whichever half is sent. An absent
 * field is left as it is; `null` goes back to the list's default.
 */
exports.saveListLayoutRequestSchema = zod_1.z.strictObject({
    view: zod_1.z.enum(exports.LIST_VIEWS).nullable().optional(),
    mobileView: zod_1.z.enum(exports.LIST_VIEWS).nullable().optional(),
    card: exports.listCardSchema.nullable().optional(),
});
//# sourceMappingURL=list-layout.js.map